// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1516227481781
      var cssReload = require("../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./views/repositories/repositories.scss
// module id = 106
// module chunks = 0